import api from '../../apiConfig/apiConfig';
import { Post, Patch, Delete } from '../base/baseAjax';
export default {
	// 邮箱host配置新增
	emailHostAdd(param) {
		return Post({
			url: api.emailHost.emailHostAdd,
			bodyParam: param,
		});
	},
	// 邮箱host配置删除
	emailHostDel(param) {
		return Delete({
			url: api.emailHost.emailHostDel,
			PathParam: param,
		});
	},
	// 邮箱host配置修改
	emailHostEdit(param) {
		return Patch({
			url: api.emailHost.emailHostEdit,
			bodyParam: param,
			PathParam: param,
		});
	},
};
